import React, { useEffect, useState } from "react";
import { api, fmtINR, fmtDate, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";

export default function CreditNotes() {
  const [rows, setRows] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ invoice_id: "", reason: "", amount: 0, date: new Date().toISOString().slice(0,10) });

  const load = async () => setRows((await api.get("/credit-notes")).data);
  useEffect(() => {
    load();
    api.get("/invoices").then((r) => setInvoices(r.data));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/credit-notes", { ...form, amount: Number(form.amount) });
      toast.success("Credit note issued");
      setShow(false);
      setForm({ invoice_id: "", reason: "", amount: 0, date: new Date().toISOString().slice(0,10) });
      load();
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-5 lb-fade" data-testid="credit-notes-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Adjustments</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">Credit Notes</h1>
          <p className="text-neutral-600 text-sm mt-1">Refunds, returns, and discounts against issued invoices.</p>
        </div>
        <button className="lb-btn" onClick={() => setShow((s) => !s)} data-testid="add-cn-btn">
          <Plus size={14} /> New Credit Note
        </button>
      </div>

      {show && (
        <form onSubmit={submit} className="lb-card p-6 grid grid-cols-4 gap-4">
          <div className="col-span-2">
            <label className="lb-label">Against Invoice</label>
            <select required className="lb-select" value={form.invoice_id}
                    onChange={(e) => setForm({ ...form, invoice_id: e.target.value })} data-testid="cn-invoice">
              <option value="">Select invoice</option>
              {invoices.map((i) => <option key={i.id} value={i.id}>{i.invoice_no} · {i.customer_snapshot?.name} · ₹{i.total}</option>)}
            </select>
          </div>
          <div>
            <label className="lb-label">Date</label>
            <input type="date" required className="lb-input" value={form.date}
                   onChange={(e) => setForm({ ...form, date: e.target.value })} />
          </div>
          <div>
            <label className="lb-label">Amount</label>
            <input type="number" step="0.01" required className="lb-input font-mono text-right"
                   value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} data-testid="cn-amount" />
          </div>
          <div className="col-span-4">
            <label className="lb-label">Reason</label>
            <input required className="lb-input" value={form.reason}
                   onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="cn-reason" />
          </div>
          <div className="col-span-4 flex gap-2">
            <button className="lb-btn" data-testid="cn-submit">Issue Credit Note</button>
            <button type="button" className="lb-btn lb-btn-ghost" onClick={() => setShow(false)}>Cancel</button>
          </div>
        </form>
      )}

      <div className="lb-card">
        <table className="lb-table">
          <thead><tr><th>CN #</th><th>Date</th><th>Invoice</th><th>Customer</th><th>Reason</th><th className="text-right">Amount</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="font-mono text-xs">{r.cn_no}</td>
                <td className="text-sm">{fmtDate(r.date)}</td>
                <td className="font-mono text-xs">{r.invoice_no}</td>
                <td className="text-sm">{r.customer_snapshot?.name}</td>
                <td className="text-sm">{r.reason}</td>
                <td className="amt">{fmtINR(r.amount)}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="text-center py-10 text-neutral-500">No credit notes</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
